import { tv } from "../../variants/tv.js";
const scrollAreaEmphasisVariants = {
    regular: {
        content: 'bg-primary-1',
        scrollbar: 'bg-neutral-4/40',
        thumb: 'bg-neutral-13/40'
    },
    medium: {
        content: 'bg-primary-3',
        scrollbar: 'bg-neutral-1/60',
        thumb: 'bg-neutral-13/40'
    },
    bold: {
        content: 'bg-primary-11 text-primary-1',
        scrollbar: 'bg-neutral-1/20',
        thumb: 'bg-neutral-1/60'
    }
};
const scrollAreaEmphases = Object.keys(scrollAreaEmphasisVariants);
const scrollAreaSlots = {
    root: 'max-w-[calc(100vw-8rem)]',
    viewport: 'outline-neutral-11/20 focus-visible:outline-primary-8 h-full overscroll-contain rounded-lg outline outline-1 -outline-offset-1 focus-visible:outline focus-visible:outline-2',
    content: 'flex flex-col gap-4 py-3 pl-4 pr-6',
    scrollbar: 'mx-1 my-2 flex w-1 justify-center rounded-full opacity-0 transition-opacity delay-300 data-[hovering]:opacity-100 data-[scrolling]:opacity-100 data-[hovering]:delay-0 data-[scrolling]:delay-0 data-[hovering]:duration-75 data-[scrolling]:duration-75',
    thumb: 'w-full rounded-full'
};
const scrollAreaHorizontalScrollbar = 'mx-2 my-1 h-1 w-auto justify-start';
const scrollAreaHorizontalThumb = 'h-full w-auto';
const scrollAreaNestedInlineHeightClass = 'max-h-[33dvh]';
const scrollAreaVariants = tv({
    slots: scrollAreaSlots,
    variants: {
        emphasis: scrollAreaEmphasisVariants,
        orientation: {
            vertical: {},
            horizontal: {
                content: 'w-max flex-row'
            },
            both: {
                content: 'w-max'
            }
        },
        popoverBody: {
            true: {
                root: 'w-full max-w-[100%]',
                viewport: 'gap-0 rounded-t-none outline-transparent outline-none',
                content: 'gap-0 bg-transparent px-0 py-0'
            }
        },
        dialogBody: {
            true: {
                root: 'w-full max-w-[100%]',
                viewport: 'gap-0 rounded-t-none rounded-b-2xl outline-transparent outline-none',
                content: 'gap-0 bg-transparent px-0 py-0'
            }
        },
        drawerBody: {
            true: {
                root: 'w-full max-w-[100%]',
                viewport: 'rounded-none outline-transparent outline-none',
                content: 'gap-0 bg-transparent px-0 py-0'
            }
        },
        nestedInline: {
            true: {
                root: `${scrollAreaNestedInlineHeightClass} overflow-hidden`,
                viewport: `${scrollAreaNestedInlineHeightClass} h-auto`
            }
        }
    },
    defaultVariants: {
        emphasis: 'regular',
        orientation: 'vertical',
        dialogBody: false,
        popoverBody: false,
        nestedInline: false
    }
});
export { scrollAreaEmphases, scrollAreaEmphasisVariants, scrollAreaHorizontalScrollbar, scrollAreaHorizontalThumb, scrollAreaNestedInlineHeightClass, scrollAreaSlots, scrollAreaVariants };
